import React, { useEffect, useState } from 'react';
import styles from '../styles/pdpl.module.scss';
import { collection, getDocs } from "firebase/firestore";
import {db} from '../config/firebase';

function PdplEn() {
    const [pdpl, setPdpl] = useState(null);

    useEffect(() => {
        fetchPost()
    }, [])

    const fetchPost = async () => {
       const usersCollectionRef = collection(db, "Contracts");
        getDocs(usersCollectionRef)
            .then((querySnapshot)=>{               
                const newData = querySnapshot.docs.filter(x => x.id === 'Pdpl En')
                if (newData.length > 0) {
                    setPdpl(newData[0].data())
                    console.log('AAA', newData[0].data())
                }
                //     .map((doc) => ({...doc.data(), id:doc.id }));              
                // console.log(newData);
            })
            .catch(e => console.error('HATA', e))
       
    }

    return (
        <div>
            <div className={styles.header}>
                <div className={styles.header__content}>
                    <div>
                        <span className={styles.logo}>Ham Yap</span>
                    </div>
                </div>
            </div>

            <div className={styles.frame}>
                <div className={styles.container1}>
                    <div className={styles.container1__text1}>
                        <p>{pdpl != null && pdpl.content.substring(0, 27)}</p>
                    </div>
                    <div className={styles.container1__text1}>
                        <p>{pdpl != null && pdpl.content.substring(28, 47)}</p>
                    </div>
                </div>
               
                <div className={styles.containerContent}>
                    <div className={styles.containerContent__text1}>
                        <p>{pdpl != null && pdpl.content.substring(48, 717)}</p>
                    </div>
                </div>

                <div className={styles.containerTitle}>
                    <div className={styles.containerTitle__text1}>
                        <p>{pdpl != null && pdpl.content.substring(718, 730)}</p>
                    </div>
                </div>
                    
                <div className={styles.containerContent}>
                    <div className={styles.containerContent__text1}>
                        <p>{pdpl != null && pdpl.content.substring(731, 793)}</p>
                        <p><strong>{pdpl != null && pdpl.content.substring(794, 808)}</strong> {pdpl != null && pdpl.content.substring(809, 885)}</p>
                        <p><strong>{pdpl != null && pdpl.content.substring(886, 915)}</strong> {pdpl != null && pdpl.content.substring(916, 1259)}</p>
                        <p><strong>{pdpl != null && pdpl.content.substring(1259, 1273)}</strong> {pdpl != null && pdpl.content.substring(1274, 1332)}</p>
                        <p><strong>{pdpl != null && pdpl.content.substring(1333, 1350)}</strong> {pdpl != null && pdpl.content.substring(1351, 1529)}</p>
                        <p><strong>{pdpl != null && pdpl.content.substring(1530, 1555)}</strong> {pdpl != null && pdpl.content.substring(1556, 1964)}</p>
                        <p>{pdpl != null && pdpl.content.substring(1965, 1972)}</p>
                    </div>
                </div>

                <div className={styles.containerTitle}>
                    <div className={styles.containerTitle__text1}>
                        <p>{pdpl != null && pdpl.content.substring(1973, 1989)}</p>
                    </div>
                </div>

                <div className={styles.containerContent}>
                    <div className={styles.containerContent__text1}>
                        <p>{pdpl != null && pdpl.content.substring(1990, 2205)}</p>
                    </div>
                </div>

                <div className={styles.containerContent}>
                    <div className={styles.containerContent__text1}>
                        <p className={styles.containerContent__innerTitle}> 
                            {pdpl != null && pdpl.content.substring(2206, 2222)}
                        </p> 
                        <p>{pdpl != null && pdpl.content.substring(2223, 2419)}</p>
                    </div>
                </div>

                <div className={styles.containerContent}>
                    <div className={styles.containerContent__text1}>
                        <p className={styles.containerContent__innerTitle}> 
                            {pdpl != null && pdpl.content.substring(2420, 2449)}
                        </p> 
                        <p>{pdpl != null && pdpl.content.substring(2450, 2584)}</p>
                    </div>
                </div>

                <div className={styles.containerTitle}>
                    <div className={styles.containerTitle__text1}>
                        <p>{pdpl != null && pdpl.content.substring(2585, 2646)}</p>
                    </div>
                </div>

                <div className={styles.containerContent}>
                    <div className={styles.containerContent__text1}>
                        <p className={styles.containerContent__innerTitle}> 
                            {pdpl != null && pdpl.content.substring(2647, 2677)}
                        </p> 
                        <ul>
                            <li>
                                {pdpl != null && pdpl.content.substring(2678, 2843)}
                            <ul>
                                <li>{pdpl != null && pdpl.content.substring(2844, 2959)}
                                    <ul>
                                        <li>
                                            {pdpl != null && pdpl.content.substring(2960, 3314)}
                                        </li>
                                    </ul>
                                </li>
                                </ul>
                            </li>
                        </ul>

                        <p className={styles.containerContent__innerTitle}> 
                            {pdpl != null && pdpl.content.substring(3315, 3368)}
                        </p> 
                        <ul>
                            <li>{pdpl != null && pdpl.content.substring(3369, 3545)}
                            <ul>
                                <li>{pdpl != null && pdpl.content.substring(3546, 3592)}
                                    <ul>
                                        <li>
                                            {pdpl != null && pdpl.content.substring(3593, 3727)}
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                            <ul>
                                <li>{pdpl != null && pdpl.content.substring(3728, 3832)}
                                    <ul>
                                        <li>
                                            {pdpl != null && pdpl.content.substring(3832, 4108)}
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                            </li>
                        </ul>
                        <br/>
                        <p>{pdpl != null && pdpl.content.substring(4109, 4345)}</p>
                    </div>
                </div>

                <div className={styles.containerContent}>
                    <div className={styles.containerContent__text1}>
                        <p className={styles.containerContent__innerTitle}> 
                            {pdpl != null && pdpl.content.substring(4346, 4377)}
                        </p> 
                        <p> 
                            {pdpl != null && pdpl.content.substring(4378, 4627)}
                        </p>
                        <br/>
                        <p> 
                            {pdpl != null && pdpl.content.substring(4628, 4937)}
                        </p>
                        <br/>
                        <p> 
                            {pdpl != null && pdpl.content.substring(4938, 5136)}
                        </p>
                    </div>
                </div>

                <div className={styles.containerTitle}>
                    <div className={styles.containerTitle__text1}>
                        <p>
                            {pdpl != null && pdpl.content.substring(5137, 5178)}
                        </p>
                    </div>
                </div>

                <div className={styles.containerContent}>
                    <div className={styles.containerContent__text1}>
                        <p> 
                            <strong>{pdpl != null && pdpl.content.substring(5179, 5193)}</strong>{pdpl != null && pdpl.content.substring(5193, 5396)}
                        </p>
                        <br/>
                        <p>
                            {pdpl != null && pdpl.content.substring(5397, 5448)}
                        </p>
                        <p>
                            {pdpl != null && pdpl.content.substring(5449, 5500)}
                        </p>
                        <p>
                            {pdpl != null && pdpl.content.substring(5500, 5569)}
                        </p>
                        <p>
                            {pdpl != null && pdpl.content.substring(5570, 5687)}
                        </p>
                        <p>
                            {pdpl != null && pdpl.content.substring(5688, 5783)}
                        </p>
                        <p>
                            {pdpl != null && pdpl.content.substring(5784, 5878)}
                        </p>
                        <p>
                            {pdpl != null && pdpl.content.substring(5878, 5999)}
                        </p>
                        <p>
                            {pdpl != null && pdpl.content.substring(6000, 6157)}
                        </p>
                        <p>
                            {pdpl != null && pdpl.content.substring(6158, 6285)}
                        </p>
                        <p>
                            {pdpl != null && pdpl.content.substring(6286, 6395)}
                        </p>
                        <p>
                            {pdpl != null && pdpl.content.substring(6396, 6464)}
                        </p>
                    </div>
                </div>

                <div className={styles.containerTitle}>
                    <div className={styles.containerTitle__text1}>
                        <p>
                            {pdpl != null && pdpl.content.substring(6465, 6503)}
                        </p>
                    </div>
                </div>

                <div className={styles.containerContent}>
                    <div className={styles.containerContent__text1}>
                        <p> 
                            {pdpl != null && pdpl.content.substring(6504, 6528)}
                        </p>
                        <ul>
                            <li>
                                {pdpl != null && pdpl.content.substring(6529, 6564)}
                            </li>
                            <li>
                                {pdpl != null && pdpl.content.substring(6565, 6667)}
                            </li>
                        </ul>
                        <br/>
                        <p> 
                            {pdpl != null && pdpl.content.substring(6667, 6689)}
                        </p>
                        <ul>
                            <li>
                                {pdpl != null && pdpl.content.substring(6690, 6757)}
                            </li>
                            <li>
                                {pdpl != null && pdpl.content.substring(6758, 6901)}
                            </li>
                            <li>
                                {pdpl != null && pdpl.content.substring(6902, 6957)}
                            </li>
                            <li>
                                {pdpl != null && pdpl.content.substring(6958, 7013)}
                            </li>
                            <li>
                                {pdpl != null && pdpl.content.substring(7014, 7153)}
                            </li>
                        </ul>
                        <br/>
                        <p>
                            {pdpl != null && pdpl.content.substring(7154, 7561)}
                        </p>
                        <br/>
                        <p>
                            {pdpl != null && pdpl.content.substring(7562, 7721)}
                        </p>
                        <br/>
                    </div>
                </div>

                <div className={styles.containerContent}>
                    <div className={styles.containerContent__text2}>
                        <p> 
                            {pdpl != null && pdpl.content.substring(7722, 7762)}
                        </p>
                        <br/>
                    </div>
                </div>

            </div>
        </div>
      
    )
}

export default PdplEn;